export const labelMap = {
    "fr-FR": "French",
    "en-US": "English",
    "de-DE": "German",
    "it-IT": "Italian",
    "nl-NL": "Dutch",
    "pt-PT": "Portuguese",
    "pt-BR": "Brazilian Portuguese",
    "es-ES": "Spanish",
}